import React, { useEffect, useRef } from 'react';
import {
  Alert,
  Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  ClickAwayListener,
  Divider,
  FormControl,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemButton,
  MenuItem,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  AccountBalanceWallet,
  Add,
  AssignmentReturn,
  Campaign,
  CardGiftcard,
  Clear,
  Close,
  Delete,
  EmojiEvents,
  Image,
  Inventory2,
  LocalOffer,
  Menu as MenuIcon,
  NoteAlt,
  NotificationsActive,
  Person,
  QrCodeScanner,
  Receipt,
  ReceiptLong,
  Remove,
  Search,
  Storefront,
  SwapHoriz,
} from '@mui/icons-material';
import ApprovalBanner from '../../components/pos/discount/ApprovalBanner';
import DashboardCatalogContent from './DashboardCatalogContent';
import DashboardExchangeWorkflowPanel from './DashboardExchangeWorkflowPanel';
import DashboardReturnSearchPanel from './DashboardReturnSearchPanel';
import GiftVoucherSalePanel from '../../components/pos/giftVoucher/GiftVoucherSalePanel';
import { GV } from '../../components/pos/giftVoucher/gvUtils';

export default function DashboardLeftPanel(props) {
  const {
    isMobile,
    isCameraScannerDevice,
    openMobileSidebar,
    onOpenMobileScanner,
    sessionBlocked,
    sessionBlockedHint,
    cartAddDisabled,
    cartAddDisabledHint,
    billingMode,
    returnOrderInput,
    setReturnOrderInput,
    returnSearchTimerRef,
    handleReturnSearch,
    setReturnSearchResults,
    setReturnOrderMatches,
    setReturnSearched,
    setSelectedReturnCustomer,
    setReturnCustomerOrders,
    setLookedUpOrder,
    searchInputRef,
    searchQuery,
    dispatch,
    setProductSearch,
    searchResults,
    isSearchingProducts,
    searchHasMore,
    isFetchingMoreResults,
    loadMoreSearchResults,
    searchHoverIndex,
    handleAddToCart,
    setSearchHoverIndex,
    getProductStock,
    onOpenStockLookup,
    handleBillingModeChange,
    categories,
    isLoadingCategories,
    selectedTab,
    setSelectedTab,
    scrollbarStyle,
    activeCategory,
    productsToShow,
    isLoadingCategoryProducts,
    categoryHasMore,
    isFetchingMoreCategoryProducts,
    loadMoreCategoryProducts,
    inStockOnly,
    setInStockOnly,
    setIsCatalogView,
    inExchangeWorkflow,
    exchangeSourceOrder,
    exchangeReturnItems,
    setExchangeReturnItems,
    reasonCodes,
    exchangeReturnTotal,
    exchangeNewItems,
    setExchangeNewItems,
    exchangeNearMissHints,
    exchangeAppliedPromotions,
    handleAddExchangeNewItem,
    handleCancelExchange,
    exchangeCustomer,
    exchangeSalesperson,
    setExchangeSalesperson,
    returnSearchResults,
    returnOrderMatches,
    returnSearched,
    selectedReturnCustomer,
    isSearchingCustomers,
    isSelectingOrder,
    handleSelectExchangeOrder,
    handleSelectReturnOrder,
    handleSelectReturnCustomer,
    lookedUpOrder,
    returnDrawerOpenDash,
    setReturnDrawerOpenDash,
    isLoadingCustomerOrders,
    cart,
    selectedProduct,
    setSelectedProduct,
    orderCartItems,
    applied_promotions = [],
    bill_discount_id,
    bill_promotion_name,
    updateQty,
    adjustQty,
    calculateItemTax,
    removeFromCart,
    near_miss_hints,
    nearMissDismissed,
    setNearMissDismissed,
    customerDetail,
    selectedCustomer,
    isCustomerDetailLoading,
    setIsCustomerDetailModalOpen,
    setIsCustomerModalOpen,
    handleRemoveCustomer,
    handleRemoveItemSalesperson,
    selectedSalesperson,
    setIsSalespersonDrawerOpen,
    handleRemoveOrderSalesperson,
    isCatalogView,
    catalogFocusIndex,
    setCatalogFocusIndex,
    catalogFocusZone,
    setCatalogFocusZone,
    bill_discount_amount,
    modeSelectRef,
    actionButtonRefs,
    handleResume,
    giftVouchersEnabled,
    onOpenVoucherSales,
    onOpenBalanceCheck,
    onOpenIncentives,
    isIncentiveProduct,
    giftVoucherPanelProps,
  } = props;
  const inGiftVoucherMode = billingMode === 'gift_voucher';

  const showMobileScannerTrigger = isCameraScannerDevice && (billingMode === 'billing' || inExchangeWorkflow);

  const searchResultRefs = useRef([]);
  useEffect(() => {
    if (searchHoverIndex >= 0) {
      searchResultRefs.current[searchHoverIndex]?.scrollIntoView({ block: 'nearest' });
    }
  }, [searchHoverIndex]);

  const closeSearchDropdown = () => {
    if ((billingMode === 'billing' || inExchangeWorkflow) && searchResults.length > 0) {
      dispatch(setProductSearch(''));
    }
  };

  return (
    <Box sx={{
      display: 'flex', flexDirection: 'column',
      width: { xs: '100%', md: '58%', lg: '50%' },
      flexGrow: { xs: 1, md: 0 },
      flexShrink: { xs: 1, md: 0 },
      minHeight: 0,
      bgcolor: '#FFF',
      borderRight: { md: '1px solid #E2E8F0' },
      overflow: 'hidden',
      position: 'relative',
    }}>
      <Box sx={{ p: 1.5, borderBottom: '1px solid #F1F5F9', display: 'flex', gap: 1, alignItems: 'center', flexShrink: 0, position: 'relative' }}>
        {isMobile && (
          <Tooltip title="Menu">
            <IconButton
              size="small"
              onClick={openMobileSidebar}
              sx={{ bgcolor: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '8px', height: 40, width: 40, color: '#1E293B', flexShrink: 0 }}
            >
              <MenuIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        <ClickAwayListener onClickAway={closeSearchDropdown}>
        <Box sx={{ flexGrow: 1, position: 'relative' }}>
          <Tooltip
            title={sessionBlocked ? sessionBlockedHint : cartAddDisabled ? cartAddDisabledHint : ''}
            disableHoverListener={!sessionBlocked && !cartAddDisabled}
            disableFocusListener={!sessionBlocked && !cartAddDisabled}
            disableTouchListener={!sessionBlocked && !cartAddDisabled}
          >
            <Box component="span" sx={{ display: 'block' }}>
              {inGiftVoucherMode ? (
                <TextField
                  key="gv-sale-search"
                  fullWidth autoFocus
                  disabled={sessionBlocked}
                  placeholder={isMobile ? 'Find a voucher sale…' : 'Find a voucher sale: receipt no. or buyer phone…'}
                  variant="outlined" size="small"
                  inputProps={{ 'aria-label': 'Find a voucher sale' }}
                  onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); onOpenVoucherSales?.((e.target.value || '').trim()); /* e.target is the <input>; currentTarget is the TextField wrapper */ } }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      bgcolor: GV.bg, borderRadius: '8px', fontSize: '0.85rem',
                      '& fieldset': { borderColor: GV.border },
                      '&:hover fieldset': { borderColor: '#F9A8D4' },
                      '&.Mui-focused fieldset': { borderColor: GV.main },
                    },
                  }}
                  InputProps={{ startAdornment: <Search sx={{ mr: 1, color: GV.main, fontSize: 18 }} /> }}
                />
              ) : (billingMode === 'return' || billingMode === 'exchange') && !inExchangeWorkflow ? (
                <TextField
                  fullWidth autoFocus
                  disabled={sessionBlocked}
                  placeholder="Search by order number or customer name…"
                  variant="outlined" size="small"
                  value={returnOrderInput}
                  onChange={(e) => {
                    const val = e.target.value;
                    setReturnOrderInput(val);

                    if (returnSearchTimerRef.current) clearTimeout(returnSearchTimerRef.current);
                    const query = val.trim();
                    if (query.length >= 2) {
                      returnSearchTimerRef.current = setTimeout(() => {
                        handleReturnSearch(query);
                      }, 350);
                    } else {
                      setReturnSearchResults([]);
                      setReturnOrderMatches([]);
                      setReturnSearched(false);
                      setSelectedReturnCustomer(null);
                      setReturnCustomerOrders([]);
                      setLookedUpOrder(null);
                    }
                  }}
                  onKeyDown={(e) => { if (e.key === 'Enter') handleReturnSearch(e.currentTarget.value); }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      bgcolor: billingMode === 'exchange' ? '#F5F3FF' : '#FFF7ED',
                      borderRadius: '8px', fontSize: '0.85rem',
                      '& fieldset': { borderColor: billingMode === 'exchange' ? '#C7D2FE' : '#FED7AA' },
                      '&:hover fieldset': { borderColor: billingMode === 'exchange' ? '#A5B4FC' : '#FDBA74' },
                      '&.Mui-focused fieldset': { borderColor: billingMode === 'exchange' ? '#6366F1' : '#C2410C' },
                    },
                  }}
                  InputProps={{
                    startAdornment: billingMode === 'exchange'
                      ? <SwapHoriz sx={{ mr: 1, color: '#6366F1', fontSize: 18 }} />
                      : <Search sx={{ mr: 1, color: '#C2410C', fontSize: 18 }} />,
                    endAdornment: returnOrderInput ? (
                      <IconButton size="small" onClick={() => { setReturnOrderInput(''); setReturnSearchResults([]); setReturnOrderMatches([]); setReturnSearched(false); setSelectedReturnCustomer(null); setReturnCustomerOrders([]); setLookedUpOrder(null); }} sx={{ color: '#94A3B8' }}>
                        <Close sx={{ fontSize: 14 }} />
                      </IconButton>
                    ) : null,
                  }}
                />
              ) : (
                <TextField
                  fullWidth autoFocus inputRef={searchInputRef}
                  disabled={sessionBlocked || cartAddDisabled}
                  placeholder="Search products..."
                  variant="outlined" size="small"
                  value={searchQuery}
                  onChange={(e) => dispatch(setProductSearch(e.target.value))}
                  sx={{ '& .MuiOutlinedInput-root': { bgcolor: '#F8FAFC', borderRadius: '8px', fontSize: '0.85rem' } }}
                  InputProps={{
                    startAdornment: showMobileScannerTrigger ? (
                      <IconButton
                        size="small"
                        aria-label="Open camera scanner"
                        disabled={sessionBlocked || cartAddDisabled}
                        onClick={onOpenMobileScanner}
                        edge="start"
                        sx={{ mr: 0.5, color: '#6366F1' }}
                      >
                        <QrCodeScanner sx={{ fontSize: 18 }} />
                      </IconButton>
                    ) : (
                      <QrCodeScanner sx={{ mr: 1, color: '#6366F1', fontSize: 18 }} />
                    ),
                    endAdornment: isSearchingProducts
                      ? <CircularProgress size={14} sx={{ color: '#94A3B8', mr: 0.5 }} />
                      : (!isMobile && <Chip label="F1" size="small" sx={{ height: 18, fontSize: '0.6rem', fontWeight: 700 }} />),
                  }}
                />
              )}
            </Box>
          </Tooltip>

          {(billingMode === 'billing' || inExchangeWorkflow) && !sessionBlocked && searchResults.length > 0 && (
            <Paper
              elevation={8}
              onScroll={(e) => {
                if (!searchHasMore || isFetchingMoreResults) return;
                const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
                if (scrollHeight - scrollTop - clientHeight < 80) loadMoreSearchResults();
              }}
              sx={{ ...scrollbarStyle, position: 'absolute', top: '105%', left: 0, right: 0, zIndex: 1300, borderRadius: '8px', maxHeight: '360px', overflowY: 'auto', border: '1px solid #CBD5E1', bgcolor: '#FFF' }}
            >
              <Box sx={{ px: 1.5, py: 0.6, borderBottom: '1px solid #F1F5F9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography sx={{ fontSize: '0.62rem', fontWeight: 700, color: '#94A3B8' }}>{searchResults.length} result{searchResults.length !== 1 ? 's' : ''}</Typography>
                {!isMobile && (
                  <Typography sx={{ fontSize: '0.6rem', color: '#CBD5E1' }}>↑↓ navigate · Enter select · Esc close</Typography>
                )}
              </Box>
              <List disablePadding>
                {searchResults.map((product, idx) => {
                  const isHighlighted = idx === searchHoverIndex;
                  return (
                    <ListItem
                      key={product.id}
                      ref={(el) => { searchResultRefs.current[idx] = el; }}
                      disablePadding
                      divider
                    >
                      <ListItemButton
                        onClick={() => { inExchangeWorkflow ? handleAddExchangeNewItem(product) : handleAddToCart(product); setSearchHoverIndex(-1); }}
                        sx={{
                          py: 0.75, px: 1.5, gap: 1.25,
                          bgcolor: isHighlighted ? '#EEF2FF' : 'transparent',
                          borderLeft: isHighlighted ? '3px solid #4F46E5' : '3px solid transparent',
                          '&:hover': { bgcolor: '#F8FAFC' },
                        }}
                      >
                        <Box sx={{ width: 32, height: 32, flexShrink: 0, bgcolor: '#F1F5F9', border: '1px solid #E2E8F0', borderRadius: '6px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          {product.image_url
                            ? <Box component="img" src={product.image_url} alt={product.name} sx={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            : <Image sx={{ color: '#CBD5E1', fontSize: 16 }} />}
                        </Box>
                        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                          <Typography noWrap sx={{ fontWeight: 600, fontSize: '0.82rem', color: isHighlighted ? '#4F46E5' : '#1E293B', lineHeight: 1.3 }}>{product.name}</Typography>
                          <Typography noWrap sx={{ fontSize: '0.68rem', color: '#94A3B8' }}>{product.sku}</Typography>
                        </Box>
                        <Box sx={{ flexShrink: 0, textAlign: 'right' }}>
                          <Typography sx={{ fontWeight: 700, color: '#4F46E5', fontSize: '0.85rem', lineHeight: 1.3 }}>₹{product.retail_price}</Typography>
                          <Typography sx={{ fontSize: '0.65rem', color: '#94A3B8' }}>Stock: {getProductStock(product)}</Typography>
                        </Box>
                      </ListItemButton>
                    </ListItem>
                  );
                })}
              </List>
              {isFetchingMoreResults && (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
                  <CircularProgress size={16} sx={{ color: '#94A3B8' }} />
                </Box>
              )}
            </Paper>
          )}
        </Box>
        </ClickAwayListener>

        <Tooltip
          title={sessionBlocked ? sessionBlockedHint : ''}
          disableHoverListener={!sessionBlocked}
          disableFocusListener={!sessionBlocked}
          disableTouchListener={!sessionBlocked}
        >
          <Box
            component="span"
            onKeyDownCapture={(e) => {
              if (document.activeElement !== modeSelectRef?.current) return;
              if (e.key === 'ArrowLeft') {
                e.preventDefault();
                e.stopPropagation();
                searchInputRef.current?.focus();
              } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                e.stopPropagation();
                actionButtonRefs?.current[1]?.focus();
              }
            }}
          >
            <FormControl
              size="small"
              sx={{ width: { xs: 44, sm: inGiftVoucherMode ? 152 : 130 }, flexShrink: 0 }}
              ref={(node) => {
                if (modeSelectRef) modeSelectRef.current = node?.querySelector('[role="combobox"]') ?? null;
              }}
            >
              <Select
                value={billingMode}
                onChange={(e) => handleBillingModeChange(e.target.value)}
                disabled={sessionBlocked}
                startAdornment={
                  inGiftVoucherMode
                    ? <CardGiftcard sx={{ color: GV.main, fontSize: 16, mr: { xs: 0, sm: 0.5 } }} />
                    : billingMode === 'return'
                    ? <AssignmentReturn sx={{ color: '#C2410C', fontSize: 16, mr: { xs: 0, sm: 0.5 } }} />
                    : billingMode === 'exchange'
                      ? <SwapHoriz sx={{ color: '#6366F1', fontSize: 16, mr: { xs: 0, sm: 0.5 } }} />
                      : <Receipt sx={{ color: '#64748B', fontSize: 16, mr: { xs: 0, sm: 0.5 } }} />
                }
                renderValue={(val) => isMobile ? '' : (val === 'billing' ? 'Billing' : val === 'return' ? 'Return' : val === 'gift_voucher' ? 'Gift Voucher' : 'Exchange')}
                sx={{
                  borderRadius: '8px', fontSize: '0.82rem', fontWeight: 600, height: 40,
                  bgcolor: billingMode === 'return' ? '#FFF7ED' : billingMode === 'exchange' ? '#F5F3FF' : inGiftVoucherMode ? GV.bg : '#F8FAFC',
                  color: billingMode === 'return' ? '#C2410C' : billingMode === 'exchange' ? '#6366F1' : inGiftVoucherMode ? GV.main : 'inherit',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: billingMode === 'return' ? '#FED7AA' : billingMode === 'exchange' ? '#C7D2FE' : inGiftVoucherMode ? GV.border : undefined,
                  },
                  '& .MuiSelect-select': { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
                  '& .MuiSelect-icon': { display: { xs: 'none', sm: 'block' } },
                }}
              >
                <MenuItem value="billing"><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Receipt sx={{ fontSize: 15, color: '#4F46E5' }} /><Typography fontSize="0.85rem" fontWeight={600}>Billing</Typography></Box></MenuItem>
                <MenuItem value="return"><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><AssignmentReturn sx={{ fontSize: 15, color: '#C2410C' }} /><Typography fontSize="0.85rem" fontWeight={600}>Return</Typography></Box></MenuItem>
                <MenuItem value="exchange"><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><SwapHoriz sx={{ fontSize: 15, color: '#6366F1' }} /><Typography fontSize="0.85rem" fontWeight={600}>Exchange</Typography></Box></MenuItem>
                {giftVouchersEnabled && <Divider />}
                {giftVouchersEnabled && <MenuItem value="gift_voucher"><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><CardGiftcard sx={{ fontSize: 15, color: GV.main }} /><Typography fontSize="0.85rem" fontWeight={600}>Gift Voucher</Typography></Box></MenuItem>}
              </Select>
            </FormControl>
          </Box>
        </Tooltip>

        {(billingMode === 'billing' || inExchangeWorkflow) && (
          <Tooltip title="Check stock at other stores &amp; warehouses">
            <IconButton
              size="small"
              onClick={onOpenStockLookup}
              sx={{ display: { xs: 'none', md: 'flex' }, bgcolor: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '8px', height: 40, width: 40, color: '#4F46E5', flexShrink: 0, '&:hover': { bgcolor: '#EEF2FF' } }}
            >
              <Storefront fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {(billingMode === 'billing' || inExchangeWorkflow) && (
          <Tooltip title={inStockOnly ? 'Showing in-stock-here only — tap to show all' : 'Show only products in stock at this store'}>
            <IconButton
              size="small"
              onClick={() => setInStockOnly?.((prev) => !prev)}
              sx={{
                display: { xs: 'none', md: 'flex' },
                bgcolor: inStockOnly ? '#EEF2FF' : '#F8FAFC',
                border: `1px solid ${inStockOnly ? '#C7D2FE' : '#E2E8F0'}`,
                borderRadius: '8px',
                height: 40,
                width: 40,
                color: inStockOnly ? '#4F46E5' : '#64748B',
                flexShrink: 0,
                '&:hover': { bgcolor: '#EEF2FF' },
              }}
            >
              <Inventory2 fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {onOpenBalanceCheck && (
          <Tooltip title="Check gift voucher balance">
            <IconButton
              size="small"
              onClick={onOpenBalanceCheck}
              aria-label="Check gift voucher balance"
              sx={{ display: { xs: 'none', md: 'flex' }, bgcolor: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '8px', height: 40, width: 40, color: GV.main, flexShrink: 0, '&:hover': { bgcolor: GV.bg } }}
            >
              <CardGiftcard fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {onOpenIncentives && (
          <Tooltip title="Incentives leaderboard">
            <IconButton
              size="small"
              onClick={onOpenIncentives}
              aria-label="Incentives leaderboard"
              sx={{ display: { xs: 'none', md: 'flex' }, bgcolor: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: '8px', height: 40, width: 40, color: '#4F46E5', flexShrink: 0, '&:hover': { bgcolor: '#EEF2FF' } }}
            >
              <EmojiEvents fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      {inGiftVoucherMode && <GiftVoucherSalePanel {...giftVoucherPanelProps} />}

      {billingMode === 'billing' && (
        <ApprovalBanner onResumeHeldOrder={(orderId) => handleResume({ id: orderId })} />
      )}

      {inExchangeWorkflow && (
        <DashboardExchangeWorkflowPanel
          exchangeSourceOrder={exchangeSourceOrder}
          exchangeReturnItems={exchangeReturnItems}
          setExchangeReturnItems={setExchangeReturnItems}
          reasonCodes={reasonCodes}
          exchangeReturnTotal={exchangeReturnTotal}
          exchangeNewItems={exchangeNewItems}
          setExchangeNewItems={setExchangeNewItems}
          nearMissHints={exchangeNearMissHints}
          appliedPromotions={exchangeAppliedPromotions}
          scrollbarStyle={scrollbarStyle}
          handleCancelExchange={handleCancelExchange}
          isIncentiveProduct={isIncentiveProduct}
        />
      )}

      {(billingMode === 'return' || billingMode === 'exchange') && !inExchangeWorkflow && (
        <DashboardReturnSearchPanel
          billingMode={billingMode}
          returnSearchResults={returnSearchResults}
          returnOrderMatches={returnOrderMatches}
          returnSearched={returnSearched}
          selectedReturnCustomer={selectedReturnCustomer}
          isSearchingCustomers={isSearchingCustomers}
          isSelectingOrder={isSelectingOrder}
          handleSelectExchangeOrder={handleSelectExchangeOrder}
          handleSelectReturnOrder={handleSelectReturnOrder}
          handleSelectReturnCustomer={handleSelectReturnCustomer}
          setSelectedReturnCustomer={setSelectedReturnCustomer}
          setReturnCustomerOrders={setReturnCustomerOrders}
          setReturnOrderInput={setReturnOrderInput}
          setReturnSearchResults={setReturnSearchResults}
          setReturnOrderMatches={setReturnOrderMatches}
          setReturnSearched={setReturnSearched}
          setLookedUpOrder={setLookedUpOrder}
          lookedUpOrder={lookedUpOrder}
          returnDrawerOpenDash={returnDrawerOpenDash}
          setReturnDrawerOpenDash={setReturnDrawerOpenDash}
          returnCustomerOrders={props.returnCustomerOrders}
          isLoadingCustomerOrders={isLoadingCustomerOrders}
        />
      )}

      {billingMode === 'billing' && (
        <TableContainer sx={{ ...scrollbarStyle, flexGrow: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
          <Table stickyHeader size="small" sx={{ '& .MuiTableBody-root .MuiTableCell-root': { py: { xs: 0.4, md: 0.6 } } }}>
            <TableHead>
              <TableRow>
                {[
                  { label: '#', sx: {} },
                  { label: 'ITEM DESCRIPTION', sx: {} },
                  { label: 'QTY', sx: {} },
                  { label: 'PRICE', sx: { display: { xs: 'none', sm: 'table-cell' } } },
                  { label: 'LINE TOTAL', sx: {} },
                  { label: '', sx: {} },
                ].map(({ label, sx }) => (
                  <TableCell key={label} sx={{ ...sx, bgcolor: '#F8FAFC', fontWeight: 800, fontSize: '0.63rem', color: '#64748B', py: 1, whiteSpace: 'nowrap' }}>{label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {cart.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} sx={{ height: { xs: 180, md: 280, lg: 380 }, textAlign: 'center', border: 0 }}>
                    <Box sx={{ opacity: 0.4 }}>
                      <ReceiptLong sx={{ fontSize: { xs: 32, md: 40 }, color: '#CBD5E1', mb: 1 }} />
                      <Typography variant="caption" sx={{ display: 'block', fontWeight: 600, color: '#94A3B8', fontSize: { xs: '0.8rem', md: '0.75rem' } }}>
                        Scan or search items to begin
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                cart.map((item, index) => {
                  const oci = orderCartItems.find((oi) => oi.product_id === item.id);
                  const netTotal = calculateItemTax(item).total;
                  // Gross = unit_price × quantity, straight from the synced backend line
                  // (falls back to local cart price×qty before the first sync response).
                  // Mirrors how the billing summary's "Subtotal" is the gross figure,
                  // separate from the post-discount "Taxable Amount".
                  const grossTotal = oci
                    ? parseFloat(oci.unit_price || 0) * parseFloat(oci.quantity || 0)
                    : (parseFloat(item.retail_price) || 0) * (parseInt(item.qty, 10) || 1);
                  const lineDiscount = parseFloat(oci?.total_discount_amount || 0);

                  return (
                  <TableRow
                    key={item.id}
                    hover
                    onClick={() => setSelectedProduct(item)}
                    sx={{ cursor: 'pointer', bgcolor: selectedProduct?.id === item.id ? '#F1F5F9' : 'inherit' }}
                  >
                    <TableCell sx={{ fontSize: '0.75rem', pr: 0, pl: { xs: 1, md: 2 } }}>{index + 1}</TableCell>
                    <TableCell sx={{ fontSize: '0.75rem', fontWeight: 600, maxWidth: { xs: 100, sm: 160, md: 'auto' } }}>
                      {(() => {
                        const linePromoAmt = parseFloat(oci?.promotion_discount_amount || 0);
                        const billPromoAmt = parseFloat(oci?.bill_promotion_discount_amount || 0);

                        const getPromoChipLabel = () => {
                          if (!oci?.promotion_name) return null;
                          const appliedPromo = applied_promotions.find((p) => p.promotion_id === oci.promotion_id);
                          const ab = appliedPromo?.applied_benefit;
                          let benefitLabel = '';
                          if (ab) {
                            if (ab.benefit_type === 'percentage_off') benefitLabel = `${parseFloat(ab.discount_value).toFixed(0)}% off`;
                            else if (ab.benefit_type === 'flat_off') benefitLabel = `₹${parseFloat(ab.discount_value).toFixed(0)} off`;
                            else if (ab.benefit_type === 'free_items') benefitLabel = 'free items';
                            else if (ab.benefit_type === 'fixed_price') benefitLabel = 'bundle price';
                            else if (ab.benefit_type === 'discounted_items') benefitLabel = `${parseFloat(ab.discount_value).toFixed(0)}% on selected`;
                          }
                          const parts = [oci.promotion_name];
                          if (benefitLabel) parts.push(benefitLabel);
                          if (linePromoAmt > 0) parts.push(`−₹${linePromoAmt.toFixed(0)}`);
                          return parts.join(' · ');
                        };

                        return (
                          <Box>
                            <Typography noWrap sx={{ fontSize: '0.75rem', fontWeight: 600 }}>{item.name}</Typography>
                            {oci?.discount_name && (
                              <Chip icon={<LocalOffer sx={{ fontSize: '10px !important' }} />} label={`${oci.discount_name} −₹${parseFloat(oci.discount_amount || 0).toFixed(0)}`} size="small" sx={{ height: 16, fontSize: '0.58rem', fontWeight: 700, bgcolor: '#F0FDF4', color: '#16A34A', mt: 0.25 }} />
                            )}
                            {oci?.promotion_name && (
                              <Chip icon={<Campaign sx={{ fontSize: '10px !important' }} />} label={getPromoChipLabel()} size="small" sx={{ height: 16, fontSize: '0.58rem', fontWeight: 700, bgcolor: '#EDE9FE', color: '#7C3AED', mt: 0.25, ml: oci?.discount_name ? 0.5 : 0 }} />
                            )}
                            {billPromoAmt > 0 && bill_promotion_name && (
                              <Chip icon={<Campaign sx={{ fontSize: '10px !important' }} />} label={`${bill_promotion_name} −₹${billPromoAmt.toFixed(0)}`} size="small" sx={{ height: 16, fontSize: '0.58rem', fontWeight: 700, bgcolor: '#EDE9FE', color: '#7C3AED', mt: 0.25, ml: (oci?.discount_name || oci?.promotion_name) ? 0.5 : 0 }} />
                            )}
                            {oci?.salesperson_name && (
                              <Box sx={{ mt: 0.25 }}>
                                <Chip
                                  icon={<Person sx={{ fontSize: '11px !important' }} />}
                                  label={`Salesperson - ${oci.salesperson_name}`}
                                  onDelete={(e) => { e.stopPropagation(); handleRemoveItemSalesperson(oci.order_item_id); }}
                                  deleteIcon={<Clear sx={{ fontSize: '12px !important' }} />}
                                  size="small"
                                  sx={{
                                    height: 18, fontSize: '0.6rem', fontWeight: 700,
                                    bgcolor: '#EFF6FF', color: '#2563EB',
                                    '& .MuiChip-icon': { color: '#2563EB', ml: '4px' },
                                    '& .MuiChip-deleteIcon': { color: '#93C5FD', '&:hover': { color: '#EF4444' } },
                                  }}
                                />
                              </Box>
                            )}
                          </Box>
                        );
                      })()}
                    </TableCell>
                    <TableCell sx={{ px: { xs: 0.5, md: 1 } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: '#F8FAFC', borderRadius: '6px', border: '1px solid #E2E8F0', overflow: 'hidden', width: 'fit-content' }}>
                        <Button onClick={(e) => { e.stopPropagation(); adjustQty(item.id, -1); }} sx={{ minWidth: { xs: 28, md: 30 }, p: 0, height: { xs: 30, md: 30 }, color: '#64748B' }}>
                          <Remove sx={{ fontSize: 15 }} />
                        </Button>
                        <InputBase
                          value={item.qty}
                          onChange={(e) => updateQty(item.id, e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                          onBlur={() => {
                            // Blank/zero is allowed transiently while retyping (backspace-to-clear) —
                            // but nothing else re-commits it, so it can sit empty forever while the
                            // row still bills the last synced quantity. Snap it back on blur.
                            if (item.qty === '' || Number.isNaN(parseInt(item.qty)) || parseInt(item.qty) < 1) {
                              updateQty(item.id, '1');
                            }
                          }}
                          inputProps={{ style: { textAlign: 'center', fontSize: '0.85rem', fontWeight: 800, width: '34px' } }}
                        />
                        <Button onClick={(e) => { e.stopPropagation(); adjustQty(item.id, 1); }} sx={{ minWidth: { xs: 28, md: 30 }, p: 0, height: { xs: 30, md: 30 }, color: '#6366F1' }}>
                          <Add sx={{ fontSize: 15 }} />
                        </Button>
                      </Box>
                    </TableCell>
                    <TableCell sx={{ fontSize: '0.75rem', display: { xs: 'none', sm: 'table-cell' } }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap' }}>
                        <span>₹{parseFloat(oci ? oci.unit_price : item.retail_price || 0).toFixed(2)}</span>
                        {item.price_capped_at_mrp && (
                          <Chip label="MRP" size="small" sx={{ height: 15, fontSize: '0.55rem', fontWeight: 700, bgcolor: '#FFFBEB', color: '#92400E', borderRadius: '4px', '& .MuiChip-label': { px: 0.5 } }} />
                        )}
                      </Box>
                    </TableCell>
                    <TableCell sx={{ px: { xs: 0.5, md: 1 } }}>
                      {lineDiscount > 0 ? (
                        <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1.25 }}>
                          <Typography
                            component="span"
                            sx={{ fontSize: { xs: '0.58rem', md: '0.65rem' }, color: '#94A3B8', textDecoration: 'line-through', whiteSpace: 'nowrap' }}
                          >
                            ₹{grossTotal.toFixed(2)}
                          </Typography>
                          <Typography component="span" sx={{ fontSize: { xs: '0.7rem', md: '0.75rem' }, fontWeight: 700, color: '#1E293B', whiteSpace: 'nowrap' }}>
                            ₹{netTotal.toFixed(2)}
                          </Typography>
                        </Box>
                      ) : (
                        <Typography component="span" sx={{ fontSize: { xs: '0.7rem', md: '0.75rem' }, fontWeight: 700, color: '#1E293B', whiteSpace: 'nowrap' }}>
                          ₹{netTotal.toFixed(2)}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell align="right" sx={{ pl: 0, pr: { xs: 1, md: 2 } }}>
                      <Delete onClick={(e) => { e.stopPropagation(); removeFromCart(item.id); }} sx={{ fontSize: { xs: 18, md: 16 }, color: '#EF4444', cursor: 'pointer' }} />
                    </TableCell>
                  </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {!inGiftVoucherMode && near_miss_hints.length > 0 && !nearMissDismissed && (
        <Box sx={{ flexShrink: 0, mx: 1.5, mb: 0.75, bgcolor: '#FFFBEB', border: '1px solid #FCD34D', borderRadius: 1.5, px: 1.25, py: 0.75 }}>
          {near_miss_hints.map((hint, idx) => (
            <Box key={hint.promotion_id}>
              {idx > 0 && <Divider sx={{ my: 0.6 }} />}
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75 }}>
                <NotificationsActive sx={{ fontSize: 14, color: '#D97706', mt: 0.2, flexShrink: 0 }} />
                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                  <Typography sx={{ fontSize: '0.68rem', fontWeight: 600, color: '#92400E', lineHeight: 1.3 }}>{hint.hint_message}</Typography>
                  <Typography sx={{ fontSize: '0.6rem', color: '#B45309' }}>{hint.promotion_name}</Typography>
                </Box>
                {idx === 0 && (
                  <IconButton size="small" onClick={() => setNearMissDismissed(true)} sx={{ p: 0.25, color: '#D97706', flexShrink: 0 }}>
                    <Close sx={{ fontSize: 13 }} />
                  </IconButton>
                )}
              </Box>
            </Box>
          ))}
        </Box>
      )}

      {inExchangeWorkflow && (
        <Box sx={{
          flexShrink: 0, px: 1.5, py: 0.6,
          borderTop: '1px solid #F1F5F9',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1,
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, minWidth: 0 }}>
            <Person sx={{ fontSize: 14, color: '#2563EB', flexShrink: 0 }} />
            <Typography noWrap sx={{ fontSize: '0.7rem', color: '#64748B' }}>
              Salesperson: {exchangeSalesperson
                ? <Box component="span" sx={{ fontWeight: 700, color: '#1E3A8A' }}>{exchangeSalesperson.name}</Box>
                : <Box component="span" sx={{ fontWeight: 600, color: '#94A3B8' }}>Not selected</Box>}
            </Typography>
          </Box>
          <Stack direction="row" spacing={0.75} alignItems="center" sx={{ flexShrink: 0 }}>
            <Typography onClick={() => setIsSalespersonDrawerOpen(true)} sx={{ fontSize: '0.65rem', fontWeight: 700, color: '#2563EB', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>{exchangeSalesperson ? 'Change' : 'Add (F6)'}</Typography>
            {exchangeSalesperson && (
              <>
                <Box sx={{ width: '1px', height: 10, bgcolor: '#E2E8F0' }} />
                <Typography onClick={() => setExchangeSalesperson(null)} sx={{ fontSize: '0.65rem', fontWeight: 700, color: '#94A3B8', cursor: 'pointer', '&:hover': { color: '#EF4444' } }}>Remove</Typography>
              </>
            )}
          </Stack>
        </Box>
      )}

      {inExchangeWorkflow && (
        <Box sx={{ flexShrink: 0, px: 1.5, py: { xs: 0.75, lg: 1.25 }, borderTop: '1px solid #EEF2FF', bgcolor: '#F5F3FF', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
          <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
            <Box sx={{ width: 28, height: 28, borderRadius: '50%', bgcolor: exchangeCustomer ? '#4F46E5' : '#CBD5E1', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <Typography sx={{ fontSize: '0.7rem', fontWeight: 900, color: '#fff', lineHeight: 1 }}>
                {(exchangeCustomer?.name || '?').charAt(0).toUpperCase()}
              </Typography>
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography noWrap sx={{ fontSize: '0.75rem', fontWeight: 800, color: exchangeCustomer ? '#3730A3' : '#94A3B8', lineHeight: 1.2 }}>
                {exchangeCustomer?.name || 'Walk-in (no customer on original bill)'}
              </Typography>
              <Typography sx={{ fontSize: '0.62rem', color: '#94A3B8', mt: 0.2 }}>From original bill</Typography>
            </Box>
          </Stack>
        </Box>
      )}

      {!inGiftVoucherMode && !inExchangeWorkflow && selectedSalesperson && (
        <Box sx={{
          flexShrink: 0, px: 1.5, py: 0.6,
          borderTop: '1px solid #F1F5F9',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1,
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, minWidth: 0 }}>
            <Person sx={{ fontSize: 14, color: '#2563EB', flexShrink: 0 }} />
            <Typography noWrap sx={{ fontSize: '0.7rem', color: '#64748B' }}>
              Salesperson: <Box component="span" sx={{ fontWeight: 700, color: '#1E3A8A' }}>{selectedSalesperson.name}</Box>
            </Typography>
          </Box>
          <Stack direction="row" spacing={0.75} alignItems="center" sx={{ flexShrink: 0 }}>
            <Typography onClick={() => setIsSalespersonDrawerOpen(true)} sx={{ fontSize: '0.65rem', fontWeight: 700, color: '#2563EB', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>Change</Typography>
            <Box sx={{ width: '1px', height: 10, bgcolor: '#E2E8F0' }} />
            <Typography onClick={handleRemoveOrderSalesperson} sx={{ fontSize: '0.65rem', fontWeight: 700, color: '#94A3B8', cursor: 'pointer', '&:hover': { color: '#EF4444' } }}>Remove</Typography>
          </Stack>
        </Box>
      )}

      {!inGiftVoucherMode && !inExchangeWorkflow && selectedCustomer && (
        <Box sx={{ flexShrink: 0, px: 1.5, py: { xs: 0.75, lg: 2 }, borderTop: '1px solid #EEF2FF', bgcolor: '#F5F3FF', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Box sx={{ width: 28, height: 28, borderRadius: '50%', bgcolor: '#4F46E5', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <Typography sx={{ fontSize: '0.7rem', fontWeight: 900, color: '#fff', lineHeight: 1 }}>
                {(customerDetail?.name || selectedCustomer.name || '?').charAt(0).toUpperCase()}
              </Typography>
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography noWrap sx={{ fontSize: '0.75rem', fontWeight: 800, color: '#3730A3', lineHeight: 1.2 }}>{customerDetail?.name || selectedCustomer.name}</Typography>
              {isCustomerDetailLoading ? (
                <Typography sx={{ fontSize: '0.62rem', color: '#94A3B8', mt: 0.2 }}>Loading customer details...</Typography>
              ) : customerDetail?.credit_balance != null ? (
                <Stack direction="row" spacing={0.4} alignItems="center" sx={{ mt: 0.2 }}>
                  <AccountBalanceWallet sx={{ fontSize: 11, color: '#16A34A' }} />
                  <Typography sx={{ fontSize: '0.62rem', color: '#16A34A', fontWeight: 700 }}>
                    Wallet: ₹{parseFloat(customerDetail.credit_balance || 0).toFixed(2)}
                  </Typography>
                </Stack>
              ) : null}
            </Box>
          </Stack>
          <Stack direction="row" spacing={0.75} alignItems="center">
            <Typography onClick={() => setIsCustomerDetailModalOpen(true)} sx={{ fontSize: '0.65rem', fontWeight: 700, color: '#4F46E5', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}>View</Typography>
            <Box sx={{ width: '1px', height: 12, bgcolor: '#C7D2FE' }} />
            <Typography onClick={() => setIsCustomerModalOpen(true)} sx={{ fontSize: '0.65rem', fontWeight: 700, color: '#6366F1', cursor: 'pointer', '&:hover': { color: '#4F46E5', textDecoration: 'underline' } }}>Change</Typography>
            <Box sx={{ width: '1px', height: 12, bgcolor: '#C7D2FE' }} />
            <Typography onClick={handleRemoveCustomer} sx={{ fontSize: '0.65rem', fontWeight: 700, color: '#94A3B8', cursor: 'pointer', '&:hover': { color: '#EF4444' } }}>Remove</Typography>
          </Stack>
        </Box>
      )}

      {isMobile && isCatalogView && (
        <Box sx={{ position: 'absolute', inset: 0, zIndex: 200, bgcolor: '#FFF', display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ px: 1.5, py: 1, borderBottom: '1px solid #E2E8F0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
            <Typography sx={{ fontWeight: 800, fontSize: '0.9rem', color: '#1E293B' }}>Product Catalog</Typography>
            <IconButton size="small" onClick={() => setIsCatalogView(false)} sx={{ color: '#64748B' }}>
              <Close fontSize="small" />
            </IconButton>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden', px: 1.5, pt: 0.5 }}>
            <DashboardCatalogContent
              isMobile={isMobile}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              categories={categories}
              isLoadingCategories={isLoadingCategories}
              scrollbarStyle={scrollbarStyle}
              activeCategory={activeCategory}
              productsToShow={productsToShow}
              isLoadingCategoryProducts={isLoadingCategoryProducts}
              categoryHasMore={categoryHasMore}
              isFetchingMoreCategoryProducts={isFetchingMoreCategoryProducts}
              loadMoreCategoryProducts={loadMoreCategoryProducts}
              inStockOnly={inStockOnly}
              setInStockOnly={setInStockOnly}
              handleAddToCart={handleAddToCart}
              disabled={cartAddDisabled}
              disabledHint={cartAddDisabledHint}
              setIsCatalogView={setIsCatalogView}
              getProductStock={getProductStock}
              catalogFocusIndex={catalogFocusIndex}
              setCatalogFocusIndex={setCatalogFocusIndex}
              catalogFocusZone={catalogFocusZone}
              setCatalogFocusZone={setCatalogFocusZone}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
